const ip = process.env.REACT_APP_BACKEND_API;
const ipAdmin = process.env.REACT_APP_BACKEND_ADMIN_API;
const urls = {};

export { urls, ip, ipAdmin };
